module.exports = __webpack_public_path__ + "static/media/trash-bin.3aca3ff6.svg";